module.exports = __webpack_public_path__ + "img/collective_management_item_bg2.4dd3d734.png";